import { render, staticRenderFns } from "./ChangeOfDirectors.vue?vue&type=template&id=79d42d50&scoped=true&"
import script from "./ChangeOfDirectors.vue?vue&type=script&lang=js&"
export * from "./ChangeOfDirectors.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfDirectors.vue?vue&type=style&index=0&id=79d42d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d42d50",
  null
  
)

export default component.exports